export default "__VITE_ASSET__DVs_3XLz__"